/** アイコン16種（spec/design/ui-design.md §6.2）。 */
export const ICON_NAMES = [
  "back",
  "next",
  "gear",
  "scroll",
  "mokuroku",
  "mute",
  "lantern",
  "reset",
  "check",
  "flag",
  "target",
  "key",
  "warn",
  "info",
  "seal",
  "pointer",
] as const;

export type IconName = (typeof ICON_NAMES)[number];

/** 家紋朱印8種（spec/design/ui-design.md §6.1）。段番号1〜7 + 免許皆伝。 */
export const MON_NAMES = [
  "mon-1",
  "mon-2",
  "mon-3",
  "mon-4",
  "mon-5",
  "mon-6",
  "mon-7",
  "mon-master",
] as const;

export type MonName = (typeof MON_NAMES)[number];

/** 未獲得の朱印の型（破線の枠のみ。ui-design.md §5.10）。 */
export const MON_BLANK_NAME = "mon-blank" as const;

export type MonBlankName = typeof MON_BLANK_NAME;
